// Labels are each language's own name, so a player can find theirs whatever the page is in.
export const allLangs = [
  {
    label: "English",
    value: "en",
    icon: "flagpack:gb-nir",
  },
  {
    label: "Español",
    value: "es",
    icon: "flagpack:es",
  },
  {
    label: "Español (Argentina)",
    value: "es-AR",
    icon: "flagpack:ar",
  },
  {
    label: "Italiano",
    value: "it",
    icon: "flagpack:it",
  },
  {
    label: "Português",
    value: "pt",
    icon: "flagpack:pt",
  },
];

export const defaultLang = allLangs[0];

export const LANG_CODES = allLangs.map((lang) => lang.value);

/** A supported code for any tag ("es-ar", "es_MX", "pt-BR"): exact match first, then the base language. */
export const matchLanguage = (tag?: string | null): string | undefined => {
  if (!tag) return undefined;
  const lower = tag.trim().replace(/_/g, "-").toLowerCase();
  const exact = LANG_CODES.find((code) => code.toLowerCase() === lower);
  if (exact) return exact;
  const base = lower.split("-")[0];
  return LANG_CODES.includes(base) ? base : undefined;
};

/** The en/es/it/pt code the backend, the translation CMS and the support widgets know. */
export const baseLanguage = (lng?: string | null): string => {
  const base = (lng || "").split("-")[0].toLowerCase();
  return LANG_CODES.includes(base) ? base : defaultLang.value;
};
